import React from 'react';
import { CATEGORIES_TOOLS } from './constants';
import { DefaultToolsReview } from './DefaultToolsReview';
import type { RelatedReport } from '@/context/Resolution886Report/types';

interface ErgonomicToolsProps {
	category: string;
	relatedReport: RelatedReport | null;
}

export function ErgonomicToolsReview({ category, relatedReport }: Readonly<ErgonomicToolsProps>): JSX.Element {
	const categoryTool = CATEGORIES_TOOLS.find((tool) => tool.category_key === category);

	if (!categoryTool?.tool) {
		return <></>;
	}

	return (
		<DefaultToolsReview
			tool={categoryTool.tool}
			name={categoryTool.name}
			relatedReport={relatedReport}
			categoryName={categoryTool.category_name}
		/>
	);
}
